<template>
    <Dialog v-model:visible="detailItemDialog" :breakpoints="{ '960px': '75vw', '640px': '100vw' }" :style="{ width: '50vw' }" header="Details" :modal="true" :maximizable="true">
        <DataTable :value="dataTable" responsiveLayout="scroll" :loading="loading" dataKey="number" @sort="onSort($event)">
            <template #header>
                <div class="flex flex-column md:flex-row md:justify-content-between md:align-items-center">
                    <div>
                        {{item.userweb_nama}}
                    </div>
                    <span class="block mt-2 md:mt-0 p-input-icon-left">
                        <i class="pi pi-search" />
                        <InputText v-model="search" placeholder="Search..." @keyup.enter="getDataTable" />
                    </span>
                </div>
            </template>
            <Column field="number" header="No." :style="{width:'20px'}" >
                <template #body="slotProps">
                {{ slotProps.data.number }}
                </template>
            </Column>
            <Column field="category" header="Category">
                <template #body="slotProps">
                {{ slotProps.data.category }}
                </template>
            </Column>
            <Column field="territory_name" header="Territory">
                <template #body="slotProps">
                {{ slotProps.data.territory_name }}
                </template>
            </Column>
            <template #empty>
                No data found.
            </template>
            <template #loading>
                Loading data. Please wait.
            </template>
            <template #footer>
                In total there are {{totalItemsCount ? totalItemsCount : 0 }} data.
            </template>
        </DataTable>

        <Paginator v-model:rows="rows" v-model:first="offset" :totalRecords="totalItemsCount" :rowsPerPageOptions="[10,20,30]">
            <template>
                {{totalItemsCount}}
            </template>
        </Paginator>

        <template #footer>
            <Button label="Back" icon="pi pi-times" class="p-button-text" @click="hideDialog"/>
        </template>

    </Dialog>
</template>

<script>

import moment from "moment";
import { mapGetters } from "vuex";
import { numberingDatatable } from "../../../utils/helpers";

export default {
    props: [
		"item",
    ],
    data() {
        return {
            loading: false,

            //detail user
            detailItemDialog: false,

            //datatables
            data: null,
            dataTable: null,
            rows: 10,
            search: null,
            offset: null,
            field: null,
            sort: null,
            page: null,
            totalItemsCount: 0,
        }
    },
    mounted() {   
        this.$store.commit('setErrors', {});
    },
    watch: {
        offset() {
            this.getDataTable();
        },
        rows() {
            this.getDataTable();
        },
        detailItemDialog: {
            handler() {
                this.clearDataTable();
                setTimeout(() => {
                    if(this.detailItemDialog == true){
                        this.getDataTable();
                    }
                }, 200);
            },
        }
    },
    computed:{
		...mapGetters("auth", ["permission"]),
    },
    methods:{
        formatDate(value) {
            if (value) {
                return moment.utc(value).format("DD-MM-YYYY");
            }
        },
        hideDialog() {
            this.detailItemDialog = false;
        },
        // DATATABLE
        getDataTable(){

            this.loading=true;
            this.page = (this.offset / this.rows) + 1;

            this.axios({
                method: 'GET',
                url: process.env.VUE_APP_ROOT_API + 'web/master-userweb/detail',
                params: {
                    "search" : this.search,
                    "per_page" : this.rows,
                    "page" : this.page,
                    "order_by" : this.field,
                    "sort_by" : this.sort,
                    "userweb_id": this.item.userweb_id,
                }
            })
            .then(res => {
              this.data = res.data.data.data;
              this.dataTable = numberingDatatable(res.data.data.data, this.page, this.rows);
              this.totalItemsCount = res.data.data.total;
              this.rows = parseInt(res.data.data.per_page);
              this.loading=false;
            })
            .catch((err) => {
                console.log(err);
                this.loading=false;
            });
         
        },
        onSort(event) {
            this.field = event.sortField;
            this.sort = event.sortOrder == '1' ? 'ASC' : 'DESC';
            this.getDataTable();
        },
        clearDataTable(){
            this.data= null;
            this.dataTable= null;
            this.rows= 10;
            this.search= null;
            this.offset= null;
            this.field= null;
            this.sort= null;
            this.page= null;
            this.totalItemsCount= 0;
        }
    }
}
</script>